import type { JSX } from "react";
const PLACEHOLDER_PATTERN = /{(\d+)}/g;

export const createExampleInfoText = (
  template: string,
  ...replacements: (JSX.Element | string)[]
): (JSX.Element | string)[] => {
  if (!template) {
    return [];
  }

  const parts: (JSX.Element | string)[] = [];
  let lastProcessedIndex = 0;
  
  template.replace(PLACEHOLDER_PATTERN, (match: string, placeholderIndex: string, matchPosition: number) => {
    if (matchPosition > lastProcessedIndex) {
      parts.push(template.substring(lastProcessedIndex, matchPosition));
    }
    
    const replacementIndex = parseInt(placeholderIndex, 10);
    if (replacements[replacementIndex] !== undefined) {
      parts.push(replacements[replacementIndex]);
    }
    
    lastProcessedIndex = matchPosition + match.length;
    return match;
  });
  
  if (lastProcessedIndex < template.length) {
    parts.push(template.substring(lastProcessedIndex));
  }
  
  return parts;
};
